export class BonusConstants{
    public static NotOpen ='Not Open ';
    public static Open = 'Open';
    public static Restricted = 'Restricted';
    public static ScheduledToClose = 'Schedule To Close';
    public static BonusRunning = 'Bonus Running';
    public static ReadyForCF = 'Ready for CF';
    public static CFRunning = 'CFRunning';
    public static ReadyForTax = 'Ready for Tax';
    public static TaxRunning = 'Tax Running';
    public static TaxRunningClose = 'Tax Running Close';
    public static NotPublished = 'Not Published';
    public static ClosedNotPublished = 'Closed – Not Published';
    public static ClosedAndPublished = 'Closed and Published';
    public static Paid = 'Paid';
    public static SourceSystemTitan = "TITAN";
    public static RunMode = "MONTHLYCC";
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/bonus-status.constants.ts